import React from 'react'

import { useStore } from 'store'

import styles from './styles.module.scss'

interface IProps {
  nickName?: string
  id?: string
}

export const UserOnlineMark: React.FC<IProps> = ({ nickName, id }) => {
  const {
    userOnline,
    profile: { selectedUser },
  } = useStore()

  // if (nickName === selectedUser?.NickName || id === selectedUser?.Id) {
  //   return <div>a</div>
  // } else
  if (
    userOnline?.checkUserIsOnline(String(nickName)) ||
    userOnline?.checkUserIsOnlineByID(String(id))
  ) {
    return <div className={styles.userOnline} />
  }

  return null
}

UserOnlineMark.displayName = 'UserOnlineMark'
